import * as React from 'react';
import { Text, Heading4 } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';
import { PhoneIcon } from '@origin-digital/icon';
import { format } from 'date-fns-tz';
import './call-us-business.scss';

export const isAEDT = (date: Date) => {
  const dateFormat = 'zzz';
  const output = format(date, dateFormat, { timeZone: 'Australia/Melbourne' });
  return output.indexOf('+11') >= 0;
};

export const defaultTimeText = '8 am - 6.30 pm AEDT';
export const daylightSavingsTimeText = '7 am - 8 pm AEDT';

const CallUsBusiness = ({ date = new Date() }) => {
  const [timesText, setTimesText] = React.useState(defaultTimeText);
  React.useEffect(() => {
    const times = isAEDT(date) ? daylightSavingsTimeText : defaultTimeText;
    setTimesText(times);
  }, []);

  return (
    <React.Fragment>
      <Box color="white" paddingY={12} marginBottom={2}>
        <Box display="flex" justifyContent="center" paddingY={1}>
          <Heading4 text="Talk to us" />
        </Box>
        <Box display="flex" justifyContent="center" paddingY={1}>
          <Text size="sm">{timesText}, Monday to Friday</Text>
        </Box>
        <Box display="flex" justifyContent="center" marginBottom={2} paddingY={1}>
          <Box display="flex" marginRight={8}>
            <PhoneIcon size={48} />
            <div className="call-us-business call-us-business__number">
              <a href="tel:1300661544">1300 661 544</a>
            </div>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default CallUsBusiness;
